import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrossmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m9.91 9 4.615-5.5a.14.14 0 0 0-.108-.23h-1.402a.286.286 0 0 0-.217.1L8.993 7.907 5.187 3.37a.28.28 0 0 0-.216-.1H3.568a.14.14 0 0 0-.107.23L8.075 9l-4.614 5.5a.14.14 0 0 0 .107.23h1.403a.286.286 0 0 0 .216-.1l3.806-4.537 3.806 4.537c.052.064.131.1.216.1h1.403a.14.14 0 0 0 .107-.23L9.91 9Z",
		fill: "#8C8C8C"
	})
});
const ForwardRef = forwardRef(SvgCrossmin);
export { ForwardRef as ReactComponent };
